
import { Product } from "@/types/product";

export const cw1: Product = {
  id: "CW-1",
  groupId: "converters-scalers",
  name: "CW-1",
  description: "The CW-1 is a HDMI 1.4b to USB 3.1 4K converter for use with Android, Linux, and Windows. Its small size allows it to discretely hide behind devices.\n\nThe CW-1 is powered by the USB port and indicates this with a blue LED. The HDMI input can take up to 4K30 4:4:4 and scale down to 1080p for USB 2.0 usage of 1080p. The CW-1 includes a USB Type-C to USB Type A cable.",
  features: [
    "1 HDMI 1.4b Input",
    "1 USB 3.1 Type-C",
    "Blue LED Power Indicator",
    "4K30 4:4:4 with Down-Scaling",
    "USB 3.1 Type-C to Type A Cable Included",
    "Dimensions: 3.16\" x 1.51\" x 0.69\" (80.26mm x 38.35mm x 17.53mm)",
    "Weight 1.9oz (55g)",
    "Aurora Multimedia products incorporate state-of-the-art technologies that surpass typical specifications and features."
  ],
  specifications: [
    "Technical",
    "Input: 1x HDMI 1.4b",
    "Output: 1x USB 3.1 Type-C",
    "Video Support: Up to 4K30 4:4:4 with Down-Scaling",
    "Power Indicator: Blue LED",
    "Mechanical",
    "Dimensions: 3.16\" x 1.51\" x 0.69\" (80.26mm x 38.35mm x 17.53mm)",
    "Weight: 1.9oz (55g)",
    "Included Accessories: USB 3.1 Type-C to Type A Cable"
  ],
  images: [
    "/lovable-uploads/dfa657fa-997b-4a01-b95b-59ac84921b8f.png",
    "/lovable-uploads/60670f94-85d5-48bc-9b4a-044b01e8a4e4.png",
    "/lovable-uploads/fc458332-baef-4b5b-8ca2-0ae221c783d4.png",
    "/lovable-uploads/bdc2364a-f86d-4733-897c-95ea40d67a90.png"
  ],
  slug: "cw-1"
};
